import React, { useContext, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, ROLE, SIZE } from 'baseui/modal';
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { faCopy, faStar as faStarSolid, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonRow } from '@gtintel/platform-atoms';
import { NPRequestStatus, ProjectStatusEnum } from '@gtintel/platform-types';
import { COLOURS } from '@gtintel/platform-utils';
import { ProjectContext, RequestsContext } from '../../context';
const Actions = ({
  id,
  canDelete,
  status,
  setIsOpen,
  setModalAssignmentId,
  isLeadPartnerAssignment
}) => {
  const projectCtx = useContext(ProjectContext);
  const {
    copy,
    remove,
    cancel,
    setLeadPartnerAssignment
  } = useContext(RequestsContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const starColour = projectCtx.hasLeadPartnerAssignment() && !isLeadPartnerAssignment ? COLOURS.gray : COLOURS.gold;
  const canMakeLead = ![String(ProjectStatusEnum.ACTIVATED), String(ProjectStatusEnum.CLOSED), String(ProjectStatusEnum.COMPLETED)].includes(projectCtx.status());
  const canCancel = [NPRequestStatus.Sent, NPRequestStatus.Declined, NPRequestStatus.Draft, NPRequestStatus.Accepted].includes(status);

  // -------------------------------------------------------------------------------------------------------------------
  // Modal actions
  // -------------------------------------------------------------------------------------------------------------------
  const action = () => {
    switch (modalTitle) {
      case 'Copy':
        copy(id);
        break;
      case 'Delete':
        remove(id);
        break;
      case 'Cancel':
        cancel(id);
        break;
      case 'Make Lead':
        makeLeadAssignment();
        break;
    }
  };
  function makeLeadAssignment() {
    if (status < NPRequestStatus.Assigned || status === NPRequestStatus.AcceptedCancelled) {
      console.log('Attempting to set via API');
      if (isLeadPartnerAssignment || !projectCtx.hasLeadPartnerAssignment()) {
        setLeadPartnerAssignment(id, !isLeadPartnerAssignment);
      }
    } else {
      console.log('Attempting to set via modal');
      if (!isLeadPartnerAssignment || !projectCtx.hasLeadPartnerAssignment()) {
        setModalAssignmentId(id);
        setIsOpen(true);
      }
    }
  }

  // -------------------------------------------------------------------------------------------------------------------

  return <React.Fragment>
      <ButtonRow flexPosition="flex-end" shrinkDirection="row">
        <Button kind="primary" size="mini" onClick={e => {
        e.stopPropagation();
        setModalTitle('Copy');
        setModalOpen(true);
      }} onKeyUp={e => {
        e.stopPropagation();
        if (e.key === 'Enter') {
          setModalTitle('Copy');
          setModalOpen(true);
        }
      }} testId={`request-list-item-copy-${id}`} title="Copy">
          <FontAwesomeIcon icon={faCopy} color="#fff" />
        </Button>

        <Button kind="secondary" size="mini" disabled={!canDelete} onClick={e => {
        e.stopPropagation();
        setModalTitle('Delete');
        setModalOpen(true);
      }} onKeyUp={e => {
        e.stopPropagation();
        if (e.key === 'Enter') {
          setModalTitle('Delete');
          setModalOpen(true);
        }
      }} testId={`request-list-item-delete-${id}`} title="Delete">
          <FontAwesomeIcon icon={faTrash} color={!canDelete ? '#aaa' : '#111'} />
        </Button>

        <Button kind="error" size="mini" onClick={e => {
        e.stopPropagation();
        setModalTitle('Cancel');
        setModalOpen(true);
      }} onKeyUp={e => {
        e.stopPropagation();
        if (e.key === 'Enter') {
          setModalTitle('Cancel');
          setModalOpen(true);
        }
      }} testId={`request-list-item-cancel-${id}`} title="Cancel" disabled={!canCancel}>
          <FontAwesomeIcon icon={faXmark} color="#fff" />
        </Button>

        <Button kind="tertiary" size="mini" testId={`request-list-item-lead-np-${id}`} disabled={!canMakeLead} onClick={e => {
        e.stopPropagation();
        setModalTitle('Make Lead');
        setModalOpen(true);
      }} onKeyUp={e => {
        e.stopPropagation();
        if (e.key === 'Enter') {
          setModalTitle('Make Lead');
          setModalOpen(true);
        }
      }} overrides={{
        Root: {
          style: {
            background: 'none',
            ':hover': {
              background: 'none'
            }
          }
        }
      }}>
          <FontAwesomeIcon icon={isLeadPartnerAssignment ? faStarSolid : faStar} color={starColour} size="lg" title={!canMakeLead ? 'Project has been activated so the lead cannot be changed here' : 'Is this a Lead Partner Assignment?'} />
        </Button>
      </ButtonRow>
      <Modal onClose={() => setModalOpen(false)} closeable isOpen={modalOpen} animate autoFocus size={SIZE.default} role={ROLE.dialog}>
        <ModalHeader>{modalTitle}</ModalHeader>
        <ModalBody>
          You are about to {modalTitle.toLocaleLowerCase()} this assignment.
          Proceed?
        </ModalBody>
        <ModalFooter>
          <Button kind="error" testId={`request-list-item-${modalTitle.toLocaleLowerCase()}-cancel`} onClick={() => {
          setModalOpen(false);
        }} onKeyUp={e => {
          e.stopPropagation();
          if (e.key === 'Enter') {
            setModalOpen(false);
          }
        }}>
            Cancel
          </Button>
          &nbsp;
          <Button kind="primary" testId={`request-list-item-${modalTitle.toLocaleLowerCase().split(' ').join('-')}`} onClick={e => {
          e.stopPropagation();
          action();
        }} onKeyUp={e => {
          e.stopPropagation();
          if (e.key === 'Enter') {
            action();
          }
        }}>
            Proceed
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>;
};
export default Actions;